var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom"},[_c('video',{ref:"video",staticClass:"custom-player",attrs:{"autoplay":true,"controls":"","poster":_vm.defaultImage}},[_c('source',{attrs:{"src":_vm.videoSrc,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }